import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'subscription'
const plural = 'subscriptions'
const single = 'subscription'

// plural and single may be used for message logic if needed in the ApiCore class.
const apiSubscription = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: true,
  url,
  plural,
  single,
})

apiSubscription.getActiveSubscription = () =>
  apiProvider.getAll(`${url}/active`)

apiSubscription.planActivate = (data) =>
  apiProvider.post(`${url}/activate`, data)

apiSubscription.getSubscriptionType = () => apiProvider.getAll(`${url}/type`)

export default apiSubscription
